<section id="stability">
    <div class=shoe-type>
    <h2 tabindex="0">Stability</h2>
    <p tabindex="0">Structured, supportive, and built to protect your feet and ankles! Stability trainers prioritize structure over speed and excessive cushioning, but that doesn't meant that they have to feel like concrete boots! These shoes are ideal for people who need a little extra support, structure, and protection from over pronation in an effort to prevent ligament damage and shin splints.</p>
    <div class="check-out">
        <h3 tabindex="0">Be sure to check out...</h3>
        <div class="row">
            <ng-container *ngFor="let shoe of stabilityShoes">
                <div class="col-lg-4">
                    <app-shoe-card [shoe]="shoe"></app-shoe-card>         
                </div>
            </ng-container>
        </div>
    </div>
</div>
</section>